import DataObject from '../../../common/model/DataObject';

export default class Parameters extends DataObject {
  useDynamicSchema() {
    return true;
  }

  useInheritedMetadataRules() {
    return false;
  }
}